import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar archivos de traducciones
import translationES from '../../locales/es.js';
import translationEN from '../../locales/en.js';
import translationFR from '../../locales/fr.js';
import translationDE from '../../locales/de.js';
import translationIT from '../../locales/it.js';
import translationPT from '../../locales/pt.js';

// Los recursos contienen las traducciones
const resources = {
  es: {
    translation: translationES
  },
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  de: {
    translation: translationDE
  },
  it: {
    translation: translationIT
  },
  pt: {
    translation: translationPT
  }
};

// Función auxiliar para comprobar si una clave existe en una traducción
const validateTranslations = () => {
  console.log('Validando traducciones...');
  // Lista de claves de ejemplo para verificar
  const keysToCheck = [
    'bubbles.home.revolution.title',
    'bubbles.home.ecosystem.title',
    'home.title',
    'bubbles.privacy.commitment.title'
  ];
  
  // Comprobamos cada idioma
  Object.keys(resources).forEach(lang => {
    console.log(`Comprobando traducciones para ${lang}:`);
    keysToCheck.forEach(key => {
      const keyParts = key.split('.');
      let current = resources[lang].translation;
      let exists = true;
      
      for (const part of keyParts) {
        if (current && current[part]) {
          current = current[part];
        } else {
          exists = false;
          break;
        }
      }
      
      console.log(`  - Clave "${key}": ${exists ? 'EXISTE' : 'NO EXISTE'}`);
    });
  });
};

i18n
  // detectar el idioma del usuario
  .use(LanguageDetector)
  // pasar la instancia i18n a react-i18next
  .use(initReactI18next)
  // inicializar i18next
  .init({
    resources,
    fallbackLng: 'es', // idioma por defecto
    debug: true, // Activamos la depuración para ver mensajes en consola
    interpolation: {
      escapeValue: false, // no es necesario para React
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage', // usar la clave que ya tienes
      caches: ['localStorage']
    }
  }, () => {
    // Validamos las traducciones al inicializar
    validateTranslations();
  });

// Función para forzar el cambio de idioma (para testing)
window.forceLanguage = (lang) => {
  console.log(`Forzando cambio de idioma a: ${lang}`);
  i18n.changeLanguage(lang);
  console.log(`Idioma actual: ${i18n.language}`);
};

export default i18n;